// removed by extract-text-webpack-plugin
module.exports = {"twoFactor":"twoFactor___202JI","twoFactorDiv":"twoFactorDiv___RamtF","twoFactorTitle":"twoFactorTitle___wjnGI","title":"title___3gjgX","codePart":"codePart___1kE1F","codePartInput":"codePartInput___2V4cm","btnWidth":"btnWidth___2aatQ","getCodeBtn":"getCodeBtn___3Ayhh","checkCodeBtn":"checkCodeBtn___pSPca"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Verification/index.less
// module id = 355
// module chunks = 0